import star_icon from './img/star_icon.svg';
import customHeaders, { getSpace } from '../../common/headers';
import { useNavigate } from 'react-router-dom';
import { useDataTable } from '../../common/hooks';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { ModalMassImprovement } from '../../components/Modal/ModalMassImprovement/ModalMassImprovement';
import { ModalContentTransfer } from '../../components/Modal/ModalContentTransfer/ModalContentTransfer';
import { ModalSuccessfulProductList } from '../../components/Modal/ModalSuccessfulProductList/ModalSuccessfulProductList';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { useState, useEffect, useRef } from 'react';
import {
  DropDownSelector,
  Tabs,
  ButtonBasic,
  SearchComponent,
  TableBox,
} from '@lk-gtcom/ecomlab-components';
import { fetchFilterV3 } from '../../common/filtersFunc';
import {
  KonstantinMasterHttps,
  ArtemTransferTestHttps,
  KonstantinCreateProductHttps,
} from '../../fetchUrls';
import useGeneralStore from '../../store/general';
import { RequestController } from '../../common/filtersFunc';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { usePushNotifications } from '../../common/pushNotification';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { useResponseHandler } from '../../common/auth';
import { FilterArticles } from '../../components/FilterArticles/FilterArticles';
import { useSavedFilters } from '../../common/useSavedFilters';
import './ProductsListMasterProduct.scss';

const btn_tab = [
  { label: 'Все', value: 'all' },
  { label: 'Готовые', value: '' },
  { label: 'Без маппинга', value: '' },
  { label: 'Удаленные (до 30 дней)', value: '' },
];

const ProductsListMasterProduct = ({
  setIsModalActive,
  isModalActive,
  transfer,
}) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved,  hasSavedFilters } = useSavedFilters(selectedSpace?.value, transfer ? 'transfer-list-master' : 'products-list-master');
  // Обработка ошибок
  const { addErrorPush, addSuccessPush } = usePushNotifications();
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  const requestControllerRef = useRef(new RequestController());

  // Фильтры
  const filterConfig = [
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' },
    { key: 'search', type: 'single' }
  ];
  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);

  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');

  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);

  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0);

  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedOfferId, setSelectedOfferId] = useState([]);

  // Search
  const [searchData, setSearchData] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [defaultSearchValue, setDefaultSearchValue] = useState('')

  const [checkedProducts, setCheckedProducts] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [showModalDone, setShowModalDone] = useState(false);
  const [isTransfer, setIsTransfer] = useState(false);

  // Таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(paginatorRef.current?.setTotal, paginatorRef);
  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;
  // Modal
  const [isModalFilter, setIsModalFilter] = useState(false);
  const [isModalMassEditing, setIsModalMassEditing] = useState(false);

  const [target, setTarget] = useState([]);
  const [selectTargetApi, setSelectTargetApi] = useState([]);
  const [pageValue, setPageValue] = useState(btn_tab[0].value);
  const navigate = useNavigate();

  const [filterValue, setFilterValue] = useState('');

  const [byFilterValue, setByFilterValue] = useState(false);
  const [filterTextValue, setFilterTextValue] = useState('');

  const resetTable = () => {
    paginatorRef.current.reset();
    paginatorRef.current.setTotal(0);
    setSort({});
    setHeaders([]);
    setFetchedData([]);
  };

  // Инициализация фильтров из URL параметров при первом рендере
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  useEffect(() => {
    if (!isReady) return;
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.category) setSelectedCategory(urlParams.category)
        if (urlParams.brand) setSelectedBrand(urlParams.brand)
        if (urlParams.search) {
          setSearchValue(urlParams.search?.value)
          setDefaultSearchValue({
            value: urlParams.search?.value,
            label: urlParams.search?.label
          })
        }

        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams, isReady]);

  useEffect(() => {
    if (!isReady) return;
    updateURL({
      category: urlParams?.category || selectedCategory,
      brand: urlParams?.brand || selectedBrand,
      search: urlParams?.search ? urlParams.search?.value : null
    })
  }, [isReady]);

  const filtersMasterCategory = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      page: categoryPage,
      set: setCategoryData,
      searchParam: categoryQuery,
      controller,
      setTotal: setTotalCategory,
      filter: 'mp_categories'
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  };

  const filtersMasterBrand = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      page: brandPage,
      selectedCategory,
      searchParam: brandQuery,
      set: setBrandData,
      controller,
      setTotal: setTotalBrand,
      filter: 'mp_brands'
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  };

  useEffect(() => {
    return () => {
      // Отменяем все активные запросы фильтров
      requestControllerRef.current.abortAll();
    };
  }, []);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersMasterCategory();
  }, [isFilterRequest, categoryPage, categoryQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersMasterBrand();
  }, [isFilterRequest, brandPage, brandQuery]);

  const fetchTableData = (params, abortController = new AbortController()) => {
    let sort;
    let filtersParam;

    if (params) {
      [sort, filtersParam] = params;
    }

    setLoading(true);

    let url = `${KonstantinMasterHttps}/master-products/tables/product-list${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''
      }`;


    let brand_id_list;
    let category_id_list;
    let offer_id_list;
    let offer_id_name_search = searchValue;

    if (selectedOfferId) {
      offer_id_list = selectedOfferId?.map((el) => el?.value);
    }

    if (selectedBrand?.length > 0) {
      brand_id_list = selectedBrand?.map((el) => el.value);
    }

    if (selectedCategory?.length > 0) {
      category_id_list = selectedCategory?.map((el) => el.value);
    }

    if (filterValue?.length > 0) {
      filtersParam = [['offer_id', 'text', '=', filterValue?.join(',')]];
    }

    const body = JSON.stringify({
      category_id_list,
      brand_id_list,
      // offer_id_list,
      page: paginatorRef.current.page,
      limit: paginatorRef.current.limit,
      filters: filtersParam,
      offer_id_name_search,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        if (!abortController.signal.aborted) {
          setLoading(false);
        }
      });
  };

  // Поиск
  const fetchSearch = ([search, page = 1], abortController = new AbortController()) => {
    let url = `${KonstantinMasterHttps}/master-products/filters/offer-id-name`;

    const body = JSON.stringify({
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      page: page,
      limit: 10,
      search_param: search,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => {
        setSearchData(
          json?.filter_data?.map(({ id, name, image }) => ({
            label: name,
            extra: id,
            value: id,
            image,
          }))
        );
      })
      .catch(handleRequestError);
  };

  // Нужно протестить
  const fetchDelete = (data, abortController = new AbortController()) => {
    const { product_id } = data;
    if (!product_id) return;

    let url = `${KonstantinCreateProductHttps}/master_products/completely-delete`;

    const body = JSON.stringify({
      product_id: product_id,
    });

    fetch(url, { body, method: 'DELETE', headers, signal: abortController.signal })
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) {
          const errorMessage = data.detail || res.statusText;
          addErrorPush(`Ошибка: ${errorMessage}`);
          throw new Error(`${res.status} ${errorMessage}`);
        }
        return data;
      })
      .then((json) => {
        addSuccessPush(`Товар удален`)
        fetchTableData([]);
      })
      .catch(handleRequestError);
  };

  const fetchTransferApi = () => {
    setIsTransfer(true);
    if ((checkedProducts.length > 0) & !isTransfer || filterValue?.length > 0) {
      const abortController = new AbortController();
      let url = `${ArtemTransferTestHttps}/avail-stores`;

      fetch(url, { method: 'GET', headers, signal: abortController.signal })
        .then(handleTableResponse)
        .then((json) => {
          const { avail_stores } = json;
          setShowModal(true);
          setTarget(
            avail_stores.map((el) => ({
              label: el.name,
              value: el.api_id,
              mp_id: el.mp_id,
              icon: el.icon,
            }))
          );
        })
        .catch(handleRequestError)
        .finally(() => setIsTransfer(false));

      return abortController;
    }
  };

  const transferApi = () => {
    // setLoading(true)

    let url = `${ArtemTransferTestHttps}/upload`;

    let offer_ids = byFilterValue
      ? filterValue
      : checkedProducts?.map((el) => {
        const offer = el?.offer_id;
        if (typeof offer === 'string') {
          return offer;
        } else {
          return offer?.join('');
        }
      });

    const body = JSON.stringify({
      ozon_api_id: '',
      offer_ids,
      target_api_id: selectTargetApi?.value,
      target_mp_id: selectTargetApi?.mp_id,
      content_mods: [],
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => { })
      .catch(handleRequestError);
  };

  const handleTransfer = () => {
    setIsTransfer(true);
    if ((checkedProducts.length > 0) & !isTransfer || filterValue?.length > 0) {
      const abortController = new AbortController();
      let url = `${ArtemTransferTestHttps}/avail-stores`;

      fetch(url, { method: 'GET', headers, signal: abortController.signal })
        .then(handleTableResponse)
        .then((json) => {
          const { avail_stores } = json;
          setShowModal(true);
          setTarget(
            avail_stores?.map((el) => ({
              label: el.name,
              value: el.api_id,
              mp_id: el.mp_id,
              icon: el.icon,
            }))
          );
        })
        .catch(handleRequestError)
        .finally(() => setIsTransfer(false));

      return abortController;
    }
  };

  useEffect(() => {
    if (showModal) {
      if (!isModalActive) {
        fetchTransferApi();
      }
    }
  }, [showModal, isModalActive]);

  const onEditProduct = (data) => {
    if (data) {
      const { product_id } = data;
      const url = `../add-product/required?isEdit=true&product_id=${product_id}`;
      window.open(url, '_blank');
    }
  };

  const contextMenuArr = [
    {
      label: 'Информация',
      onClick: (e) => {
        const { offer_id, product_id, brand_id } = e;
        window.open(
          `/analysis_sku/product_improvement/emoji?nmid=${offer_id}&product_id=${product_id}&brand_id=${brand_id}`
        );
      },
      type: '',
    },
    {
      label: 'Список связок',
      onClick: (e) => {
        const { offer_id, product_id } = e;
        window.open(
          `/analysis_sku/general?nmid=${offer_id}&product_id=${product_id}`
        );
      },
      type: '',
    },
    { label: 'Редактировать', onClick: (e) => onEditProduct(e), type: '' },
    { label: 'Удалить', onClick: (e) => fetchDelete(e), type: '' },
  ];

  useEffect(() => {
    const abortController = new AbortController();
    if (!isModalFilter && isReady) {
      fetchTableData([], abortController);
    }
    return () => abortController.abort();
  }, [selectedOfferId, isModalFilter, isTableRequest, filterValue]);

  return (
    <>
      {showModalDone &&
        <ModalSuccessfulProductList
          setIsModal={setShowModalDone}
        />
      }

      {showModal &&
        <ModalContentTransfer
          checkedProducts={checkedProducts}
          setShowModal={setShowModal}
          targetApiData={target}
          state={selectTargetApi}
          setSelectTargetApi={setSelectTargetApi}
          transferApi={transferApi}
          setShowModalDone={setShowModalDone}
          setIsModalActive={setIsModalActive}
          filterValue={filterValue}
        />
      }

      {isModalMassEditing &&
        <ModalMassImprovement
          setIsModal={setIsModalMassEditing}
          checkedProducts={checkedProducts}
        />
      }

      <div className="products-list-master-products">
        <div className="products-list-master-products__header">
          <TitlePage
            title={(transfer ? 'Перенос' : 'Список') + ` товаров`}
          />
          <div className="products-list-master-products__title-tooltip">
            Мастер товары <img src={star_icon} />
          </div>
        </div>

        <div className="products-list-master-products__toolbar-top">
          <FilterContainer
            loading={isSaved}
            saveFilters={saveFilters}
            clearSavedFilters={clearSavedFilters}
        hasSavedFilters={hasSavedFilters}
            onReset={(e) => {
              setSelectedCategory([]);
              setSelectedBrand([]);
              setFilterValue('');
              setFilterTextValue('');
              setByFilterValue(false);
              setSearchValue('')
              setSearchData([])
              updateURL({
                category: null,
                brand: null,
                search: null
              });
              setIsFilterRequest(!isFilterRequest);
              setIsTableRequest(!isTableRequest)
            }}
          >
            <DropDownSelector
              options_prop={categoryData}
              state={selectedCategory}
              setState={setSelectedCategory}
              placeholder="Категория"
              multi={true}
              total={totalCategory}
              fetchCallback={setCategoryPage}
              setInputChange={setCategoryQuery}
              onBlur={() => {
                updateURL({ category: selectedCategory });
                filtersMasterBrand();
                if (!isModalFilter) {
                  resetTable();
                }
                setIsTableRequest(!isTableRequest)
              }}
            />

            <DropDownSelector
              options_prop={brandData}
              state={selectedBrand}
              setState={setSelectedBrand}
              placeholder="Бренд"
              multi={true}
              total={totalBrand}
              fetchCallback={setBrandPage}
              setInputChange={setBrandQuery}
              onBlur={() => {
                updateURL({ brand: selectedBrand });
                filtersMasterBrand();
                if (!isModalFilter) {
                  resetTable();
                }
                setIsTableRequest(!isTableRequest)
              }}
            />

            <SearchComponent
              searchValue={searchValue}
              errSearch={false}
              placeholder="Поиск по артукулу или названию"
              errText="Неверный артикул или название"
              setSearchValue={setSearchValue}
              fetchData={(e) => setIsTableRequest(!isTableRequest)}
              fetchCallback={fetchSearch}
              data={searchData}
              onClearDependence={[isFilterRequest]}
              updateURL={updateURL}
              value={defaultSearchValue}
            />
          </FilterContainer>

          {!transfer && (
            <ButtonBasic
              violet
              icon={star_icon}
              text={'Создать товар'}
              positionIcon='right'
              width="auto"
              minWidth="150px"
              size="40px"
              onClick={(e) => navigate('/add-product/required')}
            />
          )}
        </div>

        <Tabs
          tabs={btn_tab}
          pageValue={pageValue}
          setPageValue={(e) => setPageValue(e)}
        />

        <TableBox
          {...tableProps}
          paginator={true}
          ref={paginatorRef}
          onEdit={(e) => navigate('/edit-product/add-information/required')}
          onCheck={setCheckedProducts}
          onAction={onEditProduct}
          fetchCallback={fetchTableData}
          contextMenuArr={contextMenuArr}
          child={
            <>
              <FilterArticles
                filterValue={filterValue}
                setFilterValue={setFilterValue}
              />

              <ButtonBasic
                action
                disabled={!(checkedProducts?.length > 0)}
                width="auto"
                text={`Перенести`}
                size="32px"
                onClick={(e) => {
                  handleTransfer();
                  setByFilterValue(false);
                }}
              />
              <ButtonBasic
                action
                disabled={!(checkedProducts?.length > 0)}
                width="auto"
                text={`Массовое улучшение`}
                size="32px"
                onClick={(e) => {
                  setIsModalMassEditing(true);
                  navigate('emoji');
                }}
              />

              <ButtonBasic
                disabled={filterValue?.length < 1}
                size="32px"
                width={'fit-content'}
                text="Перенести все из фильтра по артикулу"
                onClick={(e) => {
                  fetchTransferApi();
                  setByFilterValue(true);
                }}
              />
            </>
          }
        />
      </div>
    </>
  );
};

export { ProductsListMasterProduct };
